import { __extends } from "tslib";
import { DeleteProjectVersionRequest, DeleteProjectVersionResponse } from "../models/index";
import { deserializeAws_json1_1DeleteProjectVersionCommand, serializeAws_json1_1DeleteProjectVersionCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteProjectVersionCommand = /** @class */ (function (_super) {
    __extends(DeleteProjectVersionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteProjectVersionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteProjectVersionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: DeleteProjectVersionRequest.filterSensitiveLog,
            outputFilterSensitiveLog: DeleteProjectVersionResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteProjectVersionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1DeleteProjectVersionCommand(input, context);
    };
    DeleteProjectVersionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1DeleteProjectVersionCommand(output, context);
    };
    return DeleteProjectVersionCommand;
}($Command));
export { DeleteProjectVersionCommand };
//# sourceMappingURL=DeleteProjectVersionCommand.js.map